import { render, staticRenderFns } from "./InitForm.vue?vue&type=template&id=e04a077e&scoped=true"
import script from "./InitForm.vue?vue&type=script&lang=js"
export * from "./InitForm.vue?vue&type=script&lang=js"
import style0 from "./InitForm.vue?vue&type=style&index=0&id=e04a077e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04a077e",
  null
  
)

export default component.exports